import vm from "../main";

export default {
  recallOrRejectEntity(entity, name) {
    let entityName = name.toUpperCase();
    if (entity.intents[0].type === "DELETE_" + entityName) {
      entity.intents = null;
      entity.intentId = 0;
    } else if (entity.intents[0].type === "CREATE_" + entityName || entity.intents[0].type === "UPDATE_" + entityName) {
      entity.intents[0].status = "DRAFT";
    }
  },
  isEqual(obj1, obj2) {
    // Check if both objects are null or undefined
    if (obj1 === obj2) {
      return true;
    }

    // Check if either object is null or undefined
    if (typeof obj1 !== "object" || obj1 === null || typeof obj2 !== "object" || obj2 === null) {
      return false;
    }

    // Get the keys of the objects
    const keys1 = Object.keys(obj1);
    const keys2 = Object.keys(obj2);

    // Check if the number of keys is the same
    if (keys1.length !== keys2.length) {
      return false;
    }

    // Check if all keys and their values are equal
    for (let key of keys1) {
      if (!keys2.includes(key) || !this.isEqual(obj1[key], obj2[key])) {
        return false;
      }
    }

    return true;
  },
  computed: {
    uuidv4() {
      return "10000000-1000-4000-8000-100000000000".replace(/[018]/g, (c) =>
        (c ^ (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))).toString(16)
      );
    },
  },
};
